import * as React from 'react';

interface PricingSeatSelectProps {
  planId,
  seatCount,
  handleSeatChange,
  reactRef,
}

export const PricingSeatSelect = ({
  planId, seatCount, handleSeatChange, reactRef,
}: PricingSeatSelectProps) => {
  const handleDecrement = () => {
    reactRef.current.stepDown();
    handleSeatChange(reactRef.current.value);
  };
  const handleIncrement = () => {
    reactRef.current.stepUp();
    handleSeatChange(reactRef.current.value);
  };

  if (planId === 'trial-plan-4') {
    return <div className="pricing-number-input-placeholder" />;
  }

  return (
    <div className="pricing-number-input">
      <span
        role="button"
        tabIndex={0}
        onKeyPress={handleDecrement}
        onClick={handleDecrement}
      >
        -
      </span>
      <span className="input-container">
        <input
          ref={reactRef}
          className="number-input"
          type="number"
          min="1"
          max="10"
          value={seatCount}
        />
        <span className="black fsz-16 bold-800" style={{ padding: '0' }}>
          {`user${seatCount > 1 ? 's' : ''}`}
        </span>
      </span>
      <span
        role="button"
        tabIndex={0}
        onKeyPress={handleIncrement}
        onClick={handleIncrement}
      >
        +
      </span>
    </div>
  );
};
